/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M8.4632 9.75a.75.75 0 0 0-1.4142.4999c.5943 1.6814 2.0196 2.9694 3.7851 3.37a.75.75 0 1 0 .3319-1.4628c-1.2582-.2855-2.2783-1.206-2.7028-2.407Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.5 8.5c0 2.9351-1.4876 5.5227-3.75 7.05V19c0 1.2695-.8602 2.3381-2.0296 2.6547C14.5247 22.9816 13.3813 24 12 24c-1.3813 0-2.5247-1.0184-2.7204-2.3453C8.1102 21.3381 7.25 20.2695 7.25 19v-3.45C4.9876 14.0227 3.5 11.4351 3.5 8.5 3.5 3.8056 7.3056 0 12 0s8.5 3.8056 8.5 8.5Zm-1.5 0c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7Zm-8.146 13.25c.1929.4415.6334.75 1.146.75s.9531-.3085 1.146-.75h-2.292ZM12 17c1.1511 0 2.2488-.2288 3.25-.6435V19c0 .6904-.5596 1.25-1.25 1.25h-4c-.6904 0-1.25-.5596-1.25-1.25v-2.6435C9.7512 16.7712 10.8489 17 12 17Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuInnovation'
);
